import { authFetch } from 'src/auth/utils';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { DoughnutDTO } from 'src/common/components/Dashboard/Types/DashboardApiTypes';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { ObjectValues } from 'src/common/tsHelpers';
import { envVariables } from 'src/common/utils/envVariables';
import { UsageDto } from 'src/common/utils/mapUsageDTOtoAreaChartData';

export const TARIFF_SUMMARY_SUBSCRIPTION_STATUS = {
  TEST: 'Test',
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
} as const;

type TariffSummarySubscriptionStatus = ObjectValues<typeof TARIFF_SUMMARY_SUBSCRIPTION_STATUS>;

type GetTariffSummarySubscriptionStatusProps = {
  accountRef?: string;
  tariffCode?: string | null;
};

export const getTariffSummarySubscriptionStatus = async (
  { accountRef, tariffCode }: GetTariffSummarySubscriptionStatusProps,
  signal?: AbortSignal,
) => {
  const tariffSummarySubscriptionStatusResponse = await authFetch(
    `${
      envVariables.VITE_ANALYTICS_MODULE_URL
    }/usage-tracking/tariffs/pie-chart?accountRef=${accountRef}${
      tariffCode ? `&tariffCode=${tariffCode}` : ''
    }`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const tariffSummarySubscriptionStatusDTO: DoughnutDTO<TariffSummarySubscriptionStatus> =
    await tariffSummarySubscriptionStatusResponse.json();

  const data = tariffSummarySubscriptionStatusDTO.data.reduce(
    (acc, entry) => {
      acc[entry.label] = entry.value;
      return acc;
    },
    {
      [TARIFF_SUMMARY_SUBSCRIPTION_STATUS.ACTIVE]: 0,
      [TARIFF_SUMMARY_SUBSCRIPTION_STATUS.TEST]: 0,
      [TARIFF_SUMMARY_SUBSCRIPTION_STATUS.DEACTIVATED]: 0,
    },
  );

  return { data, total: tariffSummarySubscriptionStatusDTO.total };
};

type GetTariffSummaryCumulativeUsageProps = {
  accountRef: string;
  tariffCode: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
};

export const getTariffSummaryCumulativeUsage = async (
  { accountRef, tariffCode, chartType, usageType }: GetTariffSummaryCumulativeUsageProps,
  signal?: AbortSignal,
) => {
  const tariffSummaryCumulativeUsageResponse = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/usage-tracking/tariff-usage/${accountRef}/${tariffCode}/daily/${chartType}/${usageType}/linechart`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const tariffSummaryCumulativeUsageDTO: UsageDto =
    await tariffSummaryCumulativeUsageResponse.json();

  return tariffSummaryCumulativeUsageDTO.chartData;
};
